export default "__VITE_ASSET__D$$U$HAl__"